export default __webpack_public_path__ + "static/media/project4.c6afc5ac.jpg";